import dayjs from 'dayjs';

export const formatStudentDates = (date: string | undefined) => {
	const lastInteractionDate = date ? dayjs(date) : null;

	const isWithinLastWeek = lastInteractionDate && dayjs().diff(lastInteractionDate, 'day') <= 7;

	const isMoreThan21Days = (lastInteractionDate && dayjs().diff(lastInteractionDate, 'day') >= 21) || !lastInteractionDate;

	let formattedDate = '-';

	if (lastInteractionDate) {
		if (isWithinLastWeek) {
			const daysAgo = dayjs().diff(lastInteractionDate, 'day');
			formattedDate = daysAgo === 0 ? 'Bugün' : daysAgo === 1 ? 'Dün' : `${daysAgo} gün önce`;
		} else {
			formattedDate = lastInteractionDate.format('D MMMM, HH:mm');
		}
	}

	return {
		isMoreThan21Days,
		formattedDate
	};
};
